<section class="fj-about-cover" appHeroScrollCue>
        <div class="site-container fj-about-cover-grid">
            <div>
                <span class="fj-log-stamp">Owner Notes / Georgetown</span>
                <p class="eyebrow">About GTX Inspections</p>
                <h1>A local team built around calm home checkups and clear reports.</h1>
                <p>
                    GTX Inspections is a Georgetown, Texas inspection company led by Roland and Kari Moreno.
                    The business is built around accurate reports, clear communication, and careful property understanding you can trust.
                </p>
                <div class="hero-actions">
                    <a class="ng-button ng-button-primary" routerLink="/contact">Start a conversation</a>
                    <a class="ng-button ng-button-ghost" href="tel:512-848-1316">Call/Text (512) 848-1316</a>
                </div>
            </div>
            <figure>
                <img src="assets/images/design-a/kari-roland-door-field-journal.jpg" alt="Roland and Kari Moreno at a home entry" />
                <figcaption>
                    <span>Georgetown-based</span>
                    <strong>Roland and Kari Moreno</strong>
                </figcaption>
            </figure>
        </div>
    </section>

    <section class="fj-mission-quote">
        <div class="site-container fj-mission-grid">
            <blockquote>
                <span>Mission statement</span>
                <p>
                    "Generate the most accurate report possible, give every home the attention it deserves,
                    and leave clients with the information needed to make an informed decision."
                </p>
            </blockquote>
            <div class="fj-proof-wall" aria-label="GTX owner experience">
                <div *ngFor="let proof of proofPoints">
                    <strong>{{ proof.value }}</strong>
                    <span>{{ proof.label }}</span>
                </div>
            </div>
        </div>
    </section>

    <section class="fj-owner-story-band">
        <div class="site-container">
            <article class="fj-owner-story">
                <img src="assets/images/design-a/roland-bridge-standing-field-journal.jpg" alt="Roland Moreno" loading="lazy" />
                <div>
                    <p class="eyebrow">Lead inspector / TREC# 23635</p>
                    <h2>Roland Moreno</h2>
                    <p>
                        I am the owner and lead inspector of GTX Inspections, LLC. My mission is to generate the
                        most accurate report possible for my clients. I do not rush my inspections because I want to
                        give your home the attention it deserves.
                    </p>
                    <p>
                        At the end of every inspection, I spend quality time with my clients and their agents educating
                        them on the home and its current condition. My reports provide the necessary information for my
                        clients to make an informed decision.
                    </p>
                    <p>
                        I worked as a senior project manager for 21 years and a general superintendent for 2 years
                        before becoming a professional home inspector. During those years, the most important takeaway
                        for me was developing valuable customer service that exceeded the industry's expectations.
                    </p>
                    <div class="credential-list">
                        <span>Construction background</span>
                        <span>Client walk-throughs</span>
                        <span>Fluent in Spanish</span>
                    </div>
                </div>
            </article>

            <article class="fj-owner-story reverse">
                <img src="assets/images/design-a/kari-bridge-field-journal.jpg" alt="Kari Moreno" loading="lazy" />
                <div>
                    <p class="eyebrow">Owner and administrator</p>
                    <h2>Kari Moreno</h2>
                    <p>
                        I am the owner and administrator of GTX Inspections, LLC. I bring a vast knowledge and background
                        of administration duties which I hope to be of benefit to our clients.
                    </p>
                    <p>
                        I have been a serving member of the Georgetown community since 2011 working in early childhood
                        development programs throughout local church ministries and volunteering through local schools
                        and sports booster programs both fundraising and serving our community throughout the years and seasons.
                    </p>
                    <p>
                        I look forward to returning to my administration roots providing our clients with the best customer
                        service I have to offer, and I will continue to strive for a level of commitment and professionalism
                        that serves our clients well.
                    </p>
                    <div class="credential-list">
                        <span>Administration background</span>
                        <span>Georgetown community service since 2011</span>
                        <span>Friendly scheduling support</span>
                    </div>
                </div>
            </article>
        </div>
    </section>

    <section class="fj-values-wall">
        <div class="site-container fj-values-grid">
            <div>
                <p class="eyebrow">Why choose GTX</p>
                <h2>Accurate reporting, local experience, and time spent explaining the inspection.</h2>
                <p>
                    Buying and selling your home is an experience to be remembered and an investment to be protected.
                    GTX uses education, experience, and integrity to help safeguard that investment.
                </p>
                <div class="hero-actions">
                    <a class="ng-button ng-button-primary" routerLink="/contact">Contact GTX</a>
                    <a class="ng-button ng-button-secondary" href="tel:512-848-1316">Call/Text (512) 848-1316</a>
                </div>
            </div>
            <div class="fj-commitment-list">
                <article *ngFor="let commitment of ownerCommitments">
                    <span>{{ commitment.title }}</span>
                    <p>{{ commitment.description }}</p>
                </article>
                <div class="fj-local-marker-list">
                    <span *ngFor="let marker of localMarkers">{{ marker }}</span>
                </div>
            </div>
        </div>
    </section>
